import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../general/title"
import colorArray from "../../helpers/colorArray"
import _ from "lodash"
import { HorizontalBar, Bar, Pie } from "react-chartjs-2"
import clone from "clone"
import lineOptions from "helpers/lineOptions"
import times from "helpers/times"
import ImageExport from "components/ImageExport"
import ReactSelect from "components/ReactSelect"
import FullTable from "components/FullTable"
import numeral from "numeral"
import helpers from "helpers/helpers"
import ExcelOnly from "components/ExcelOnly"

class Demographics extends Component {
	constructor(props) {
		super(props)
		this.year = new Date().getFullYear()
		this.state = {
			times: times(),
			activeLotTypes: [],
			ages: ["18 - 24", "25 - 34", "35 - 44", "45 - 54", "55 - 64", "65+"],
			hideFlags: {
				buyerAge: null,
				totalNumber: null,
				occupation: null,
				firstTime: null,
				movingWithin: null,
				trafficSource: null,
				typeMovingWithin: null,
				typeTotalNumber: null,
				typeIsMoving: null,
				zipCodes: null,
			},
			years: [(this.year - 1).toString(), this.year.toString()],
			filteredBuyerAge: [],
			filteredTotalNumber: [],
			filteredIsMoving: [],
			filteredFirstTime: [],
			sorted: {
				buyerAge: [],
				totalNumber: [],
				isMoving: [],
				firstTime: [],
			},
			columns: {
				buyerAge: [
					{
						Header: "Lot Type",
						accessor: "lot_type",
						filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
					},
					{
						Header: "18 - 24",
						accessor: "18 - 24",
						Cell: (v) => (!v.value ? 0 : v.value),
					},
					{
						Header: "25 - 34",
						accessor: "25 - 34",
						Cell: (v) => (!v.value ? 0 : v.value),
					},
					{
						Header: "35 - 44",
						accessor: "35 - 44",
						Cell: (v) => (!v.value ? 0 : v.value),
					},
					{
						Header: "45 - 54",
						accessor: "45 - 54",
						Cell: (v) => (!v.value ? 0 : v.value),
					},
					{
						Header: "55 - 64",
						accessor: "55 - 64",
						Cell: (v) => (!v.value ? 0 : v.value),
					},
					{
						Header: "65+",
						accessor: "65+",
						Cell: (v) => (!v.value ? 0 : v.value),
					},
				],
				totalNumber: [
					{
						Header: "Lot Type",
						accessor: "lot_type",
						filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
					},
					{
						Header: "1",
						accessor: "1",
						Cell: (v) => (!v.value ? 0 : v.value),
					},
					{
						Header: "2",
						accessor: "2",
						Cell: (v) => (!v.value ? 0 : v.value),
					},
					{
						Header: "3",
						accessor: "3",
						Cell: (v) => (!v.value ? 0 : v.value),
					},
					{
						Header: "4",
						accessor: "4",
						Cell: (v) => (!v.value ? 0 : v.value),
					},
					{
						Header: "5",
						accessor: "5",
						Cell: (v) => (!v.value ? 0 : v.value),
					},
					{
						Header: "6",
						accessor: "6",
						Cell: (v) => (!v.value ? 0 : v.value),
					},
					{
						Header: "7",
						accessor: "7",
						Cell: (v) => (!v.value ? 0 : v.value),
					},
				],
				isMoving: [
					{
						Header: "Lot Type",
						accessor: "lot_type",
						filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
					},
					{
						Header: "Yes",
						accessor: "Yes",
					},
					{
						Header: "No",
						accessor: "No",
					},
				],
				firstTime: [
					{
						Header: "Lot Type",
						accessor: "lot_type",
						filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
					},
					{
						Header: "Yes",
						accessor: "Yes",
					},
					{
						Header: "No",
						accessor: "No",
					},
				],
			},
			tableOccupations: [],
		}
	}

	flipPDF = (name, value) => {
		let flags = clone(this.state.hideFlags)
		flags[name] = value
		this.setState({ hideFlags: flags })
	}

	buyerAge = () => {
		let ret = {}
		let labels = _.clone(this.state.ages)
		_.forEach(labels, (v) => {
			if (!_.has(ret, v)) {
				_.set(ret, v, 0)
			}
		})
		let count = 0
		// total them first
		_.forEach(this.props.payload.sales.current, (v) => {
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
			if (!v.primary_age) {
				return
			}
			if (!_.has(ret, `${v.primary_age}`)) {
				_.set(ret, `${v.primary_age}`, 0)
			}
			ret[v.primary_age]++
			count++
		})
		_.forEach(this.props.payload.bustouts.current, (v) => {
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
			if (!v.primary_age) {
				return
			}
			if (!_.has(ret, `${v.primary_age}`)) {
				_.set(ret, `${v.primary_age}`, 0)
			}
			ret[v.primary_age]--
			count--
		})
		const data = {
			labels: _.keys(ret),
			datasets: [
				{
					data: _.values(ret),
					backgroundColor: colorArray,
				},
			],
		}
		let tableData = []
		_.forEach(ret, (v, k) => {
			tableData.push({ Age: k, Sales: v })
		})
		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
			plugins: {
				datalabels: {
					formatter: (value, ctx) => {
						let sum = 0
						let dataArr = ctx.chart.data.datasets[0].data
						dataArr.map((data) => {
							sum += data
						})
						let percentage = Math.round((value * 100) / sum) + "%"
						return percentage
					},
				},
			},
		}
		count = numeral(count).format("0,0")
		return (
			<>
				<h3 className="statBox__title" style={{ marginBottom: 5 }}>
					Buyer Age
				</h3>
				<p className="small" style={{ marginTop: 0 }}>
					Based on {count} sales.
				</p>
				<div className="flex justify-end">
					<ImageExport name="BuyerAge" block={true} twoUp={true} />
					<ExcelOnly data={tableData} index={0} title="BuyerAge" />
				</div>
				<div id="buyerAge">
					<Pie data={data} options={opts} />
				</div>
			</>
		)
	}

	totalNumber = () => {
		let ret = {}
		let d = []
		let count = 0
		_.forEach(this.props.payload.sales.current, (v) => {
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
			if (!v.num_residents) {
				return
			}
			let path = `${v.num_residents}`
			if (!_.has(ret, path)) {
				_.set(ret, path, 0)
			}
			//ret[v.num_residents] += parseInt(v.num_residents)
			ret[v.num_residents]++
			count++
		})
		_.forEach(this.props.payload.bustouts.current, (v) => {
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
			if (!v.num_residents) {
				return
			}
			let path = `${v.num_residents}`
			if (!_.has(ret, path)) {
				_.set(ret, path, 0)
			}
			//ret[v.num_residents] -= parseInt(v.num_residents)
			ret[v.num_residents]--
			count--
		})
		_.forEach(ret, (v, k) => {
			d.push({
				label: k,
				backgroundColor: colorArray[k],
				borderColor: colorArray[k],
				borderWidth: 1,
				data: [v],
			})
		})
		const data = {
			labels: ["Total Number of Residents"],
			datasets: d,
		}
		count = numeral(count).format("0,0")
		let tableData = []
		_.forEach(ret, (v, k) => {
			tableData.push({ "Total Residents": k, Sales: v })
		})
		return (
			<>
				<h3 className="statBox__title" style={{ marginBottom: 5 }}>
					Total # of Residents
				</h3>
				<p className="small" style={{ marginTop: 0 }}>
					Based on {count} sales.
				</p>
				<div className="flex justify-end">
					<ImageExport name="TotalNumberResidents" block={true} twoUp={true} />
					<ExcelOnly data={tableData} index={0} title="TotalNumber" />
				</div>
				<div id="totalNumber">
					<HorizontalBar data={data} options={lineOptions} />
				</div>
			</>
		)
	}

	firstTime = () => {
		let ret = {}
		let count = 0
		// total them first
		_.forEach(this.props.payload.sales.current, (v) => {
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
			if (v.first_time == null) return
			let l = v.first_time === 1 ? "Yes" : "No"
			if (!_.has(ret, `${l}`)) {
				_.set(ret, `${l}`, 0)
			}
			count++
			ret[l]++
		})
		_.forEach(this.props.payload.bustouts.current, (v) => {
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
			if (v.first_time == null) return
			let l = v.first_time === 1 ? "Yes" : "No"
			if (!_.has(ret, `${l}`)) {
				_.set(ret, `${l}`, 0)
			}
			count--
			ret[l]--
		})

		const data = {
			labels: ["First Time Buyer"],
			datasets: [
				{
					label: "Yes",
					backgroundColor: colorArray[1],
					borderColor: colorArray[1],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: [ret["Yes"]],
				},
				{
					label: "No",
					backgroundColor: colorArray[8],
					borderColor: colorArray[8],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: [ret["No"]],
				},
			],
		}
		count = numeral(count).format("0,0")
		let tableData = []
		_.forEach(ret, (v, k) => {
			tableData.push({ "First Time": k, Sales: v })
		})
		return (
			<>
				<h3 className="statBox__title" style={{ marginBottom: 5 }}>
					First Time Buyer
				</h3>
				<p className="small" style={{ marginTop: 0 }}>
					Based on {count} sales.
				</p>
				<div className="flex justify-end">
					<ImageExport name="FirstTime" block={true} twoUp={true} />
					<ExcelOnly data={tableData} index={0} title="FirstTime" />
				</div>
				<div id="firstTime">
					<HorizontalBar data={data} options={lineOptions} />
				</div>
			</>
		)
	}

	movingWithin = () => {
		let ret = {}
		// total them first
		let count = 0
		_.forEach(this.props.payload.sales.current, (v) => {
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
			if (v.is_moving_within === null) return
			let l = v.is_moving_within === 1 ? "Yes" : "No"
			if (!_.has(ret, `${l}`)) {
				_.set(ret, `${l}`, 0)
			}
			ret[l]++
			count++
		})

		_.forEach(this.props.payload.bustouts.current, (v) => {
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
			if (v.is_moving_within === null) return
			let l = v.is_moving_within === 1 ? "Yes" : "No"
			if (!_.has(ret, `${l}`)) {
				_.set(ret, `${l}`, 0)
			}
			ret[l]--
			count--
		})

		const data = {
			labels: ["Is Moving Within?"],
			datasets: [
				{
					label: "Yes",
					backgroundColor: colorArray[1],
					borderColor: colorArray[1],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: [ret["Yes"]],
				},
				{
					label: "No",
					backgroundColor: colorArray[8],
					borderColor: colorArray[8],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: [ret["No"]],
				},
			],
		}
		count = numeral(count).format("0,0")
		let tableData = []
		_.forEach(ret, (v, k) => {
			tableData.push({ "Moving Within": k, Sales: v })
		})
		return (
			<>
				<h3 className="statBox__title" style={{ marginBottom: 5 }}>
					Is Moving Within?
				</h3>
				<p className="small" style={{ marginTop: 0 }}>
					Based on {count} sales.
				</p>
				<div className="flex justify-end">
					<ImageExport name="MovingWithin" block={true} twoUp={true} />
					<ExcelOnly data={tableData} index={0} title="MovingWithin" />
				</div>
				<div id="movingWithin">
					<HorizontalBar data={data} options={lineOptions} />
				</div>
			</>
		)
	}

	trafficSource = () => {
		// First compile a list of all types
		let t = []
		let count = 0
		for (let v of this.props.payload.sales.current) {
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) continue
			//if (v.bustout_date) continue
			t.push(v.traffic_source)
		}
		t = _.uniq(t)
		let sources = {}
		for (let v of t) {
			//if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) continue
			let source = _.find(this.props.payload.public.trafficSources, { id: v })
			if (source) {
				sources[source.name] = 0
			}
		}

		for (let v of this.props.payload.sales.current) {
			//if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) continue
			let source = _.find(this.props.payload.public.trafficSources, { id: v.traffic_source })
			if (source) {
				sources[source.name]++
				count++
			}
		}
		for (let v of this.props.payload.bustouts.current) {
			//if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) continue
			let source = _.find(this.props.payload.public.trafficSources, { id: v.traffic_source })
			if (source) {
				sources[source.name]--
				count--
			}
		}
		_.forEach(sources, (v, k) => {
			if (isNaN(v)) sources[k] = 0
		})
		const data = {
			labels: _.keys(sources),
			datasets: [
				{
					data: _.values(sources),
					backgroundColor: colorArray,
				},
			],
		}
		count = numeral(count).format("0,0")
		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}
		let tableData = []
		_.forEach(sources, (v, k) => {
			tableData.push({ Source: k, Sales: v })
		})
		return (
			<>
				<h3 className="statBox__title" style={{ marginBottom: 5 }}>
					Traffic Source
				</h3>
				<p className="small" style={{ marginTop: 0 }}>
					Based on {count} sales and based on builder feedback.
				</p>
				<div className="flex justify-end">
					<ImageExport name="TrafficSource" block={true} twoUp={true} />
					<ExcelOnly data={tableData} index={0} title="TrafficSource" />
				</div>
				<div id="trafficSource">
					<Pie data={data} options={opts} />
				</div>
			</>
		)
	}

	buyerOriginalSource = () => {
		// First compile a list of all types
		let t = []
		let count = 0
		for (let v of this.props.payload.sales.current) {
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) continue
			if (v.bustout_date) continue
			if (v.original_source && v.original_source !== "OFFLINE")
				t.push(_.startCase(v.original_source.toLowerCase()))
		}
		t = _.uniq(t)
		let sources = {}
		for (let v of t) {
			sources[_.startCase(v)] = 0
		}
		for (let v of this.props.payload.sales.current) {
			if (v.bustout_date) continue
			if (v.original_source && v.original_source !== "OFFLINE") {
				sources[_.startCase(v.original_source.toLowerCase())]++
				count++
			}
		}
		const data = {
			labels: _.keys(sources),
			datasets: [
				{
					data: _.values(sources),
					backgroundColor: colorArray,
				},
			],
		}
		if (count === 0) return null
		count = numeral(count).format("0,0")
		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}
		let tableData = []
		_.forEach(sources, (v, k) => {
			tableData.push({ Source: k, Sales: v })
		})
		return (
			<>
				<h3 className="statBox__title" style={{ marginBottom: 5 }}>
					Buyer Original Marketing Source
				</h3>
				<p className="small" style={{ marginTop: 0 }}>
					Based on {count} actual sales. Tracked by the communities CRM.
				</p>
				<div className="flex justify-end">
					<ImageExport name="OriginalSource" block={true} twoUp={true} />
					<ExcelOnly data={tableData} index={0} title="OriginalSource" />
				</div>
				<div id="trafficSource">
					<Pie data={data} options={opts} />
				</div>
			</>
		)
	}

	zipCodes = () => {
		// First compile a list of all types
		let count = 0
		let zips = {}
		for (let v of this.props.payload.sales.current) {
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) continue
			if (!v.buyer_zip) {
				continue
			}
			let path = `${v.buyer_zip}`
			if (!_.has(zips, path)) {
				_.setWith(zips, path, 0, Object)
			}
			count++
			zips[path]++
		}
		for (let v of this.props.payload.bustouts.current) {
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) continue
			if (!v.buyer_zip) {
				continue
			}
			let path = `${v.buyer_zip}`
			if (!_.has(zips, path)) {
				_.setWith(zips, path, 0, Object)
			}
			count--
			zips[path]--
		}
		zips = Object.entries(zips)
		let sorted = _.sortBy(zips, (v) => v[1])
		sorted = _.reverse(sorted)
		sorted = _.slice(sorted, 0, 15)

		const data = {
			labels: _.map(sorted, (v) => v[0]),
			datasets: [
				{
					data: _.map(sorted, (v) => v[1]),
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}
		count = numeral(count).format("0,0")
		let tableData = []
		_.forEach(sorted, (v, k) => {
			tableData.push({ Zip: v[0], Sales: v[1] })
		})
		return (
			<>
				<h3 className="statBox__title" style={{ marginBottom: 5 }}>
					Buyer Zip Codes
				</h3>
				<p className="small" style={{ marginTop: 0 }}>
					Based on {count} sales.
				</p>
				<div className="flex justify-end">
					<ImageExport name="ZipCodes" block={true} twoUp={true} />
					<ExcelOnly data={tableData} index={0} title="ZipCodes" />
				</div>
				<div id="zipCodes">
					<Pie data={data} options={opts} />
				</div>
			</>
		)
	}

	householdIncome = () => {
		let count = 0
		let store = {}
		for (let v of this.props.payload.sales.current) {
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) continue
			if (!v.household_income) {
				continue
			}
			let path = `${v.household_income}`
			if (!_.has(store, path)) {
				_.setWith(store, path, 0, Object)
			}
			count++
			store[path]++
		}
		for (let v of this.props.payload.bustouts.current) {
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) continue
			if (!v.household_income) {
				continue
			}
			let path = `${v.household_income}`
			if (!_.has(store, path)) {
				_.setWith(store, path, 0, Object)
			}
			count--
			store[path]--
		}
		if (_.isEmpty(store)) return null
		store = Object.entries(store)
		let sorted = _.sortBy(store, (v) => v[1])
		sorted = _.reverse(sorted)
		sorted = _.slice(sorted, 0, 15)

		const data = {
			labels: _.map(sorted, (v) => v[0]),
			datasets: [
				{
					data: _.map(sorted, (v) => v[1]),
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}
		count = numeral(count).format("0,0")
		let tableData = []
		_.forEach(sorted, (v, k) => {
			tableData.push({ Income: v[0], Sales: v[1] })
		})
		return (
			<div className="statBox__box avoid" data-html2canvas-ignore={this.state.hideFlags.householdIncome}>
				<h3 className="statBox__title" style={{ marginBottom: 5 }}>
					Household Income
				</h3>
				<p className="small" style={{ marginTop: 0 }}>
					Based on {count} sales.
				</p>
				<div className="flex justify-end">
					<ImageExport name="HouseholdIncome" block={true} twoUp={true} />
					<ExcelOnly data={tableData} index={0} title="HouseholdIncome" />
				</div>
				<div id="householdIncome">
					<Pie data={data} options={opts} />
				</div>
			</div>
		)
	}

	numChildren = () => {
		let count = 0
		let store = {}
		for (let v of this.props.payload.sales.current) {
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) continue
			if (!v.num_children) {
				continue
			}
			let path = `${v.num_children}`
			if (!_.has(store, path)) {
				_.setWith(store, path, 0, Object)
			}
			count++
			store[path]++
		}
		for (let v of this.props.payload.bustouts.current) {
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) continue
			if (!v.num_children) {
				continue
			}
			let path = `${v.num_children}`
			if (!_.has(store, path)) {
				_.setWith(store, path, 0, Object)
			}
			count--
			store[path]--
		}
		if (_.isEmpty(store)) return null
		store = Object.entries(store)
		let sorted = _.sortBy(store, (v) => v[1])
		sorted = _.reverse(sorted)
		sorted = _.slice(sorted, 0, 15)

		const data = {
			labels: _.map(sorted, (v) => v[0]),
			datasets: [
				{
					data: _.map(sorted, (v) => v[1]),
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}
		count = numeral(count).format("0,0")
		let tableData = []
		_.forEach(sorted, (v, k) => {
			tableData.push({ NumberChildren: v[0], Sales: v[1] })
		})
		return (
			<div className="statBox__box avoid" data-html2canvas-ignore={this.state.hideFlags.numChildren}>
				<h3 className="statBox__title" style={{ marginBottom: 5 }}>
					Number of Children
				</h3>
				<p className="small" style={{ marginTop: 0 }}>
					Based on {count} sales.
				</p>
				<div className="flex justify-end">
					<ImageExport name="NumberChildren" block={true} twoUp={true} />
					<ExcelOnly data={tableData} index={0} title="NumberChildren" />
				</div>
				<div id="numberChildren">
					<Pie data={data} options={opts} />
				</div>
			</div>
		)
	}

	married = () => {
		let count = 0
		let store = {
			Yes: 0,
			No: 0,
		}
		for (let v of this.props.payload.sales.current) {
			if (v.married === null) continue
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) continue
			if (v.married === 1) store["Yes"]++
			else if (v.married === 0) store["No"]++
			count++
		}

		for (let v of this.props.payload.bustouts.current) {
			if (v.married === null) continue
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) continue
			count--
			if (v.married === 1) store["Yes"]--
			else if (v.married === 0) store["No"]--
		}
		if (store["Yes"] === 0) return null // this dev probably isn't tracking, so don't show it
		store = Object.entries(store)
		let sorted = _.sortBy(store, (v) => v[1])
		sorted = _.reverse(sorted)
		sorted = _.slice(sorted, 0, 15)

		const data = {
			labels: _.map(sorted, (v) => v[0]),
			datasets: [
				{
					data: _.map(sorted, (v) => v[1]),
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}
		count = numeral(count).format("0,0")
		let tableData = []
		_.forEach(sorted, (v, k) => {
			tableData.push({ Married: v[0], Sales: v[1] })
		})
		return (
			<div className="statBox__box avoid" data-html2canvas-ignore={this.state.hideFlags.married}>
				<h3 className="statBox__title" style={{ marginBottom: 5 }}>
					Married
				</h3>
				<p className="small" style={{ marginTop: 0 }}>
					Based on {count} sales.
				</p>
				<div className="flex justify-end">
					<ImageExport name="Married" block={true} twoUp={true} />
					<ExcelOnly data={tableData} index={0} title="Married" />
				</div>
				<div id="married">
					<Pie data={data} options={opts} />
				</div>
			</div>
		)
	}

	occupation = () => {
		let ret = {}
		// total them first
		_.forEach(this.props.payload.sales.current, (v) => {
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
			let occupation = _.find(this.props.payload.public.occupations, { value: v.primary_occupation })
			if (!occupation) {
				return
			}

			if (!_.has(ret, `${occupation.label}`)) {
				_.set(ret, `${occupation.label}`, 0)
			}
			ret[occupation.label]++
		})
		_.forEach(this.props.payload.bustouts.current, (v) => {
			if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
			let occupation = _.find(this.props.payload.public.occupations, { value: v.primary_occupation })
			if (!occupation) {
				return
			}

			if (!_.has(ret, `${occupation.label}`)) {
				_.set(ret, `${occupation.label}`, 0)
			}
			ret[occupation.label]--
		})

		let tableData = []
		_.forEach(ret, (v, k) => {
			tableData.push({
				occupation: k,
				total: v,
			})
		})
		const columns = [
			{
				Header: "Occupation",
				accessor: "occupation",
				filterMethod: (f, r) => helpers.tableText(f, r, "occupation"),
			},
			{
				Header: "Total",
				accessor: "total",
			},
		]

		return (
			<div className="statBox__row" data-html2canvas-ignore={this.state.hideFlags.occupation}>
				<div className="statBox__box">
					<h3 className="statBox__title">Occupation</h3>
					<FullTable data={tableData} columns={columns} name="occupation" title="Occupation" />
				</div>
			</div>
		)
	}

	lotTypeBuyerAge = () => {
		let ret = {}
		let data = []
		_.forEach(this.props.payload.sales.current, (v) => {
			if (!v.primary_age || !v.lotTypeName) {
				return
			}
			let path = `${v.lotTypeName}.${v.primary_age}`
			if (!_.has(ret, path)) {
				_.set(ret, path, 0)
			}
			ret[v.lotTypeName][v.primary_age]++
		})
		_.forEach(this.props.payload.bustouts.current, (v) => {
			if (!v.primary_age || !v.lotTypeName) {
				return
			}
			let path = `${v.lotTypeName}.${v.primary_age}`
			if (!_.has(ret, path)) {
				_.set(ret, path, 0)
			}
			ret[v.lotTypeName][v.primary_age]--
		})

		_.forEach(ret, (v, lotType) => {
			data.push({
				lot_type: lotType,
				"18 - 24": v["18 - 24"],
				"25 - 34": v["25 - 34"],
				"35 - 44": v["35 - 44"],
				"45 - 54": v["45 - 54"],
				"55 - 64": v["55 - 64"],
				"65+": v["65+"],
			})
		})
		return data
	}

	lotTypeTotalNumber = () => {
		let ret = {}
		let data = []
		_.forEach(this.props.payload.sales.current, (v) => {
			if (!v.num_residents || !v.lotTypeName) {
				return
			}
			let path = `${v.lotTypeName}.${v.num_residents}`
			if (!_.has(ret, path)) {
				_.setWith(ret, path, 0, Object)
			}
			ret[v.lotTypeName][v.num_residents] += parseInt(v.num_residents)
		})
		_.forEach(this.props.payload.bustouts.current, (v) => {
			if (!v.num_residents || !v.lotTypeName) {
				return
			}
			let path = `${v.lotTypeName}.${v.num_residents}`
			if (!_.has(ret, path)) {
				_.setWith(ret, path, 0, Object)
			}
			ret[v.lotTypeName][v.num_residents] -= parseInt(v.num_residents)
		})
		_.forEach(ret, (v, lotType) => {
			let f = {
				lot_type: lotType,
			}
			for (let i = 1; i <= 7; i++) {
				f[i] = v[i]
			}
			data.push(f)
		})
		return data
	}

	lotTypeIsMoving = () => {
		let ret = {}
		let data = []
		_.forEach(this.props.payload.sales.current, (v) => {
			if (!v.lotTypeName) {
				return
			}
			let l = v.is_moving_within === 1 ? "Yes" : "No"
			let path = `${v.lotTypeName}.${l}`
			if (!_.has(ret, path)) {
				_.setWith(ret, path, 0, Object)
			}
			ret[v.lotTypeName][l]++
		})
		_.forEach(this.props.payload.bustouts.current, (v) => {
			if (!v.lotTypeName) {
				return
			}
			let l = v.is_moving_within === 1 ? "Yes" : "No"
			let path = `${v.lotTypeName}.${l}`
			if (!_.has(ret, path)) {
				_.setWith(ret, path, 0, Object)
			}
			ret[v.lotTypeName][l]--
		})
		_.forEach(ret, (v, lotType) => {
			data.push({
				lot_type: lotType,
				Yes: v.Yes,
				No: v.No,
			})
		})
		return data
	}

	lotTypeFirstTime = () => {
		let ret = {}
		let data = []
		_.forEach(this.props.payload.sales.current, (v) => {
			if (!v.lotTypeName) {
				return
			}
			let l = v.first_time === 1 ? "Yes" : "No"
			let path = `${v.lotTypeName}.${l}`
			if (!_.has(ret, path)) {
				_.setWith(ret, path, 0, Object)
			}
			ret[v.lotTypeName][l]++
		})
		_.forEach(this.props.payload.bustouts.current, (v) => {
			if (!v.lotTypeName) {
				return
			}
			let l = v.first_time === 1 ? "Yes" : "No"
			let path = `${v.lotTypeName}.${l}`
			if (!_.has(ret, path)) {
				_.setWith(ret, path, 0, Object)
			}
			ret[v.lotTypeName][l]--
		})
		_.forEach(ret, (v, lotType) => {
			data.push({
				lot_type: lotType,
				Yes: v.Yes,
				No: v.No,
			})
		})
		return data
	}

	lotTypes = () => {
		let ret = []
		_.forEach(this.props.payload.public.lot_types, (v) => {
			if (this.props.activeProperties.includes(v.property)) {
				let property = _.find(this.props.payload.public.properties, { id: v.property })
				let name = property.name || ""
				ret.push({
					label: this.props.activeProperties.length > 1 ? `${name} - ${v.name}` : `${v.name}`,
					value: v.id,
				})
			}
		})
		return ret
	}

	previousOwnership = () => {
		try {
			let customTypes = [
				"previous_ownership", // This is Rent or Own
			]
			// First find if any of the custom Types are being used
			let hasCustomTypes = []
			_.forEach(this.props.payload.sales.current, (v) => {
				_.forEach(customTypes, (t) => {
					if (v.buyer_addl?.[t]) {
						hasCustomTypes.push(t)
					}
				})
			})
			//? Previous Ownership - Rent or Own Pie chart.
			if (hasCustomTypes.includes("previous_ownership")) {
				let ret = {}
				let count = 0
				_.forEach(this.props.payload.sales.current, (v) => {
					if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
					if (!v.buyer_addl || !v.buyer_addl.previous_ownership) return
					let path = `${v.buyer_addl.previous_ownership}`
					if (!_.has(ret, path)) {
						_.setWith(ret, path, 0, Object)
					}
					ret[path]++
					count++
				})
				_.forEach(this.props.payload.bustouts.current, (v) => {
					if (this.state.activeLotTypes.length > 0 && !this.state.activeLotTypes.includes(v.lot_type)) return
					if (!v.buyer_addl || !v.buyer_addl.previous_ownership) return
					let path = `${v.buyer_addl.previous_ownership}`
					if (!_.has(ret, path)) {
						_.setWith(ret, path, 0, Object)
					}
					ret[path]--
					count--
				})
				const data = {
					labels: _.keys(ret),
					datasets: [
						{
							data: _.values(ret),
							backgroundColor: colorArray,
						},
					],
				}
				count = numeral(count).format("0,0")
				let tableData = []
				_.forEach(ret, (v, k) => {
					tableData.push({ PreviousOwnership: k, Sales: v })
				})
				return (
					<>
						<h3 className="statBox__title" style={{ marginBottom: 5 }}>
							Previous Ownership
						</h3>
						<p className="small" style={{ marginTop: 0 }}>
							Based on {count} sales.
						</p>
						<div className="flex justify-end">
							<ImageExport name="PreviousOwnership" block={true} twoUp={true} />
							<ExcelOnly data={tableData} index={0} title="PreviousOwnership" />
						</div>
						<div id="previousOwnership">
							<Pie data={data} options={{ legend: { display: true, position: "bottom" } }} />
						</div>
					</>
				)
			}
		} catch (e) {
			console.log(e)
		}

		return null
	}

	render() {
		if (this.props.payloadStatus) {
			return (
				<div className="demographics">
					<div className="imageGroup">
						<Title title="Demographics Report" hideFlags={this.state.hideFlags} />
						<div className="statBox">
							<div className="activeLotTypes__lotType">
								<h4 className="font-semibold">Active Lot Types:</h4>
								<ReactSelect
									name={`activeLotType`}
									options={this.lotTypes()}
									value={this.state.activeLotTypes}
									onBlur={() => {}}
									onChange={(k, v) => {
										if (!v) v = []
										this.setState({ activeLotTypes: v })
									}}
									isMulti
								/>
							</div>
							<div className="statBox__row statBox__row--double">
								<div
									className="statBox__box avoid"
									data-html2canvas-ignore={this.state.hideFlags.buyerAge}>
									{this.buyerAge()}
								</div>
								<div
									className="statBox__box avoid"
									data-html2canvas-ignore={this.state.hideFlags.totalNumber}>
									{this.totalNumber()}
								</div>
							</div>
						</div>
						<div className="statBox">
							<div className="statBox__row statBox__row--double">
								<div
									className="statBox__box avoid"
									data-html2canvas-ignore={this.state.hideFlags.movingWithin}>
									{this.movingWithin()}
								</div>
								<div
									className="statBox__box avoid"
									data-html2canvas-ignore={this.state.hideFlags.firstTime}>
									{this.firstTime()}
								</div>
							</div>
						</div>
					</div>
					<div className="imageGroup">
						<div className="statBox">
							<div className="statBox__row statBox__row--double">
								<div
									className="statBox__box avoid"
									data-html2canvas-ignore={this.state.hideFlags.trafficSource}>
									{this.trafficSource()}
								</div>
								<div
									className="statBox__box avoid"
									data-html2canvas-ignore={this.state.hideFlags.zipCodes}>
									{this.zipCodes()}
								</div>
							</div>
							<div className="statBox__row statBox__row--double">
								{this.householdIncome()}
								{this.numChildren()}
							</div>
							<div className="statBox__row statBox__row--double">
								{this.married()}
								<div
									className="statBox__box avoid"
									data-html2canvas-ignore={this.state.hideFlags.buyerOriginalSource}>
									{this.buyerOriginalSource()}
								</div>
							</div>
						</div>
					</div>
					<div className="imageGroup">
						<div className="statBox" data-html2canvas-ignore={this.state.hideFlags.occupation}>
							<div className="statBox__row statBox__row--double">
								<div
									className="statBox__box avoid"
									data-html2canvas-ignore={this.state.hideFlags.previousOwnership}>
									{this.previousOwnership()}
								</div>
							</div>
						</div>
					</div>
					<div className="imageGroup">
						<div className="statBox" data-html2canvas-ignore={this.state.hideFlags.typeMovingWithin}>
							{this.occupation()}
							<h2>Lot Type Breakout</h2>
							<div>
								<h3 style={{ marginTop: 75 }}>Buyer Age</h3>
								<FullTable
									data={this.lotTypeBuyerAge()}
									columns={this.state.columns.buyerAge}
									name="buyerAge"
									title="Buyer Age"
								/>
							</div>
						</div>
						<div className="statBox" data-html2canvas-ignore={this.state.hideFlags.typeTotalNumber}>
							<h3 style={{ marginTop: 75 }}>Total Number of Residents</h3>
							<FullTable
								data={this.lotTypeTotalNumber()}
								columns={this.state.columns.totalNumber}
								name="total"
								title="Lot Type Total Number Residents"
							/>
						</div>
					</div>
					<div className="imageGroup">
						<div className="statBox" data-html2canvas-ignore={this.state.hideFlags.typeIsMoving}>
							<h3 style={{ marginTop: 75 }}>Is Moving Within</h3>
							<FullTable
								data={this.lotTypeIsMoving()}
								columns={this.state.columns.isMoving}
								name="isMoving"
								title="Moving Within"
							/>
						</div>
						<div className="statBox" data-html2canvas-ignore={this.state.hideFlags.typeFirstTime}>
							<h3 style={{ marginTop: 75 }}>First Time Buyer</h3>
							<FullTable
								data={this.lotTypeFirstTime()}
								columns={this.state.columns.firstTime}
								name="firstTime"
								title="First Time"
							/>
						</div>
					</div>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(Demographics)
